<template>
  <div class="bg-[#FAFAFA]">
    <NavigationView />
    <div>
      <BannerView
        v-if="this.blog_details.length > 0"
        :blog="this.blog_details[0]"
      />
    </div>
    <RelatedBlogs />
    <div class="pt-6 lg:pt-12">
      <!-- <FooterView /> -->
      <DynamicfooterView />
      <SocialMedia />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NavigationView from "@/components/NavigationView.vue";
import BannerView from "@/components/Blog/BlogView/BannerView.vue";
import RelatedBlogs from "@/components/Blog/BlogView/RelatedBlogs.vue";
// import FooterView from "@/components/Home/FooterView.vue";
import SocialMedia from "@/components/SocialMedia.vue";
import DynamicfooterView from "@/components/Blog/BlogView/BlogFooterView.vue"
export default {
  name: "Blog_internal&single",
  data() {
    return {
      blog_details: [],
    };
  },
  components: {
    NavigationView,
    BannerView,
    RelatedBlogs,
    // FooterView,
    SocialMedia,
    DynamicfooterView,
  },
  props: ["slug"],
  created() {
    this.callBlog();
  },
  methods: {
    callBlog() {
      axios
        .get(`${process.env.VUE_APP_API}/blog/blog-list/?slug=${this.slug}`)
        .then((resp) => {
          console.log("resp", resp);
          if (resp.data.data) {
            this.blog_details = resp.data.data;
          } else {
            this.$router.push({
              name: "PageNotFound",
              params: { pathMatch: "page-not-found" },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>
